/*
 * Shopify native checkout from a product page (Shrine 1.9.0).
 * Use the theme's existing product-form.handleSubmit implementation. That code
 * understands product variants, quantities, line-item properties, bundles and
 * the skip-cart flow, then redirects to Shopify's own /checkout URL.
 *
 * The handler checks event.target.dataset.skipCartButton, so pass the button as
 * the explicit target, not a nested label/icon that might receive the DOM click.
 */
(function () {
  function bindNativeCheckout(button) {
    const productForm = button.closest('product-form');
    if (!productForm) return;
    const addButton = productForm.querySelector('[id^="ProductSubmitButton-"]');

    const syncAvailability = () => {
      if (!addButton) return;
      button.disabled = addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
    };

    if (addButton) {
      syncAvailability();
      new MutationObserver(syncAvailability).observe(addButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (button.disabled || button.classList.contains('loading')) return;

      if (typeof productForm.handleSubmit !== 'function') {
        console.error('Shopify native checkout: product form handler is unavailable');
        return;
      }

      // Reuse the built-in Shrine skip-cart code, which adds the selected items
      // through Shopify's cart API and redirects to Shopify /checkout on success.
      productForm.handleSubmit({
        preventDefault() {},
        target: button,
        currentTarget: button
      });
    });
  }

  function initialize() {
    document.querySelectorAll('[data-native-checkout="true"]').forEach(button => {
      if (button.dataset.nativeCheckoutBound) return;
      button.dataset.nativeCheckoutBound = 'true';
      bindNativeCheckout(button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Theme sections may be re-rendered by the Shopify editor.
  document.addEventListener('shopify:section:load', initialize);
})();
